import {MAP_PROPS_ANIMAL_CONFIG} from "@/config/globalAnimalFrontEndConfig";
import {ERROR_WAIT_BLOCK, STEP_WAIT_BLOCK} from '../../AdminProtectora/actions/actionsAdmin';
import {getItemLocalStorage} from "@/Utils/utils";

export const GET_ANIMALS = 'GET_ANIMALS';
export const GET_ANIMALS_BY_FILTER = 'GET_ANIMALS_BY_FILTER';
export const LOAD_PROTECTORA_DETAIL = 'LOAD_PROTECTORA_DETAIL';
export const CHANGE_INFO_ANIMAL_DETAIL = 'CHANGE_INFO_ANIMAL_DETAIL';
export const CHANGE_ELEMENTS_PER_ROW = 'CHANGE_ELEMENTS_PER_ROW';
export const MODE_EMAIL = "MODE_EMAIL";
export const IMAGE_LOADED = "IMAGE_LOADED";
export const IMAGE_ERROR = "IMAGE_ERROR";
export const CHANGE_IS_READY = "CHANGE_IS_READY";
export const RESET_READY = "RESET_READY";
export const CHANGE_IS_REMOVING = "CHANGE_IS_REMOVING";

export const GET_ANIMALS_PROTECTORA = "GET_ANIMALS_PROTECTORA";
export const GET_ANIMALS_RECOMENDATION = "GET_ANIMALS_RECOMENDATION";
export const CHANGE_ELEMENTS_PER_ROW_PROTECTORA = "CHANGE_ELEMENTS_PER_ROW_PROTECTORA";
export const IMAGE_LOADED_PROTECTORA = "IMAGE_LOADED_PROTECTORA";
export const IMAGE_ERROR_PROTECTORA = "IMAGE_ERROR_PROTECTORA";
export const CHANGE_IS_READY_PROTECTORA = "CHANGE_IS_READY_PROTECTORA";
export const RESET_READY_PROTECTORA = "RESET_READY_PROTECTORA";
export const SHOW_ANIMAL_DETAIL_PROTECTORA = "SHOW_ANIMAL_DETAIL_PROTECTORA";
export const HIDE_ANIMAL_DETAIL_PROTECTORA = "HIDE_ANIMAL_DETAIL_PROTECTORA";
export const LOAD_PROTECTORA_DETAIL_PROTECTORA = "LOAD_PROTECTORA_DETAIL_PROTECTORA";
export const CHANGE_INFO_ANIMAL_DETAIL_PROTECTORA = "CHANGE_INFO_ANIMAL_DETAIL_PROTECTORA";
export const MODE_EMAIL_PROTECTORA = "MODE_EMAIL_PROTECTORA";
export const MODE_EMAIL_PROTECTORA_2 = "MODE_EMAIL_PROTECTORA_2";
export const LOAD_IMAGEN_VIDEO_PROTECTORA = "LOAD_IMAGEN_VIDEO_PROTECTORA";
export const SHOW_IMAGEN_VIDEO_PROTECTORA = "SHOW_IMAGEN_VIDEO_PROTECTORA ";
export const CHANGE_IS_REMOVING_PROTECTORA = 'CHANGE_IS_REMOVING_PROTECTORA';
export const SAVE_INFO_RAZA = "SAVE_INFO_RAZA";


// =========================================================================
//                             GETS ANIMALS
// =========================================================================

// -------------------------
// GENERAL
// -------------------------


export function getAnimalsByFilter(filter, actionType, time_init, from) {
    return (dispatch, getState) => {
        let dataLS = getItemLocalStorage('initDataBE-animalList')

        if (dataLS){
            return dispatch({type: (actionType) ? actionType : GET_ANIMALS_BY_FILTER, payload: dataLS});
        } else {

            let datos = {
                filter: parserFilter(filter.filter),
                metadata: parserMetadata(filter.metadata)
            }
            $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                //data: JSON.stringify(datos),
                data: datos,
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // URL a la que se enviará la solicitud Ajax
                url: "/api/busqueda/animal",
            })
                .done(function (response, textStatus, jqXHR) {
                    dispatch({type: (actionType) ? actionType : GET_ANIMALS_BY_FILTER, payload: response});
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    let errorStr;
                    if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                        errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                    } else {
                        errorStr = jqXHR.responseJSON;
                    }

                    if (console && console.log){
                        console.log("La solicitud a fallado: " + errorStr);
                    }
                });
            // });
        }

    }
}

export function getAnimalsRecomendation(filter, actionType) {
    return (dispatch, getState) => {

        let datos = {...filter}
        datos.num = filter.metadata.num;
        datos.pag = filter.metadata.pag;
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: datos,
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/busqueda/avanzada",
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);

                dispatch({type: (actionType) ? actionType : GET_ANIMALS, payload: response});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
        // });
    }

}

// -------------------------
// PROTECTORA
// -------------------------

/** @deprecated
 *
 * @param info
 * @returns {(function(*, *): void)|*}
 */
export function getAnimalsProtectora(info) {
    return (dispatch, getState) => {
        console.warn("Method actionsAnimalList::getAnimalsProtectora() deprecated. Use actionsAnimalList::getAnimalsByFilter()");
        //console.log("actionsAnimalList::getAnimalsProtectora()");
        const filterControlProtectora = getState().filterAnimalsProtectora
        let datos = parserBasicData(filterControlProtectora);
        datos.num = info.numPerPage;
        datos.pag = info.pag;
        datos.id_protectora = info.varsData.id_protectora;
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: datos,
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/busqueda/avanzada",
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);

                // let onpage = 0;
                // let elements = [];

                // response.result.forEach(function (data) {
                //     if (data.img_principal && getState().animalsProtectora.imagesurl.indexOf(data.img_principal.url) < 0) {
                //         onpage++;
                //     }
                //     if (data.img_principal && data.img_principal.url) {
                //         elements.push(data.img_principal.url);
                //     }
                // });


                response.pag = info.pag;
                response.elementsPerRow = info.numPerRow;
                response.elementsPerPage = info.numPerPage;
                // response.imagesOnPage = onpage;
                response.imagesLoaded = 0;
                response.imagesError = 0;
                response.isReady = false;
                response.isRemoving = false;
                // response.imagesurl = elements;
                dispatch({type: GET_ANIMALS_PROTECTORA, payload: response});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }

}

/** @deprecated
 *
 * @param info
 * @returns {(function(*, *): void)|*}
 */
export function getAnimalsProtectoraAvanzado(info) {
    return (dispatch, getState) => {
        console.warn("Method actionsAnimalList::getAnimalsProtectora() deprecated. Use actionsAnimalList::getAnimalsByFilter()");
        //axios.get('http://jsonplaceholder.typicode.com/users/')
        /*axios.get('https://adopta-un-animal-be-preprod.herokuapp.com/busqueda/basica', { params: { razas: ['Dálmata, Beagle']} })
         .then((response) => {
         console.log(response);
         dispatch({type: GET_ANIMALS, payload: response.data});
         });*/
        // console.log("getAnimalsProtectoraAvanzado::()");
        let datos = parserBasicData(getState().filterAnimalsProtectora);
        let datosAvanzados = parserAdvancedData(getState().filterAnimalsProtectora);
        datos.num = info.numPerPage;
        datos.pag = info.pag;
        datos.id_protectora = info.varsData.id_protectora;
        //Compruebo primero que no hay alguno ya mostrándose.
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: $.extend({}, datos, datosAvanzados),
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/busqueda/avanzada",
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);
                // console.log("getAnimalsProtectoraAvanzado::():: done");
                let onpage = 0;
                let elements = [];

                response.result.forEach(function (data) {
                    if (data.img_principal && getState().animalsProtectora.imagesurl?.indexOf(data.img_principal.url) < 0){
                        onpage++;
                    }
                    if (data.img_principal && data.img_principal.url){
                        elements.push(data.img_principal.url);
                    }
                });


                response.pag = info.pag;
                response.elementsPerRow = info.numPerRow;
                response.elementsPerPage = info.numPerPage;
                response.imagesOnPage = onpage;
                response.imagesLoaded = 0;
                response.imagesError = 0;
                response.isReady = false;
                response.isRemoving = false;
                response.imagesurl = elements;
                dispatch({type: GET_ANIMALS_PROTECTORA, payload: response});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}


// -------------------------
// FUNCIONES AUXILIARES GETS
// -------------------------


function parserMetadata(metadata) {
    return metadata
}

function parserFilter(filter) {
    let dataReturn = {};
    Object.keys(filter).forEach((val) => {
        if (val === "especie" && filter[val] !== undefined){
            if (filter[val] !== MAP_PROPS_ANIMAL_CONFIG.especie.default.value){
                dataReturn.especie = filter[val];
            }
        } else if (val === "sexo" && filter[val] !== undefined){
            if (filter[val] === MAP_PROPS_ANIMAL_CONFIG.sexo.macho.value || filter[val] === MAP_PROPS_ANIMAL_CONFIG.sexo.hembra.value){
                dataReturn.sexo = filter[val];
            }
        } else if (val === "tamano" && filter[val] !== undefined && filter[val].length > 0){
            dataReturn.tamano = filter[val].join(",");
        } else if (val === "edades" && filter[val] !== undefined && filter[val].length > 0){
            dataReturn.edad = filter[val].join(",");
        } else if (val === "razas" && filter[val] !== undefined && filter[val].length > 0){
            if (filter[val].findIndex(x => x === "TODAS") < 0){
                dataReturn.raza = filter[val].join(",");
            }
        } else if (val === "raza" && filter[val] !== undefined && filter[val].length > 0){
            // if (data[val] !== "TODAS") {
            if (filter[val] !== undefined){
                dataReturn.raza = filter[val];
            }
        }
        if (val === "estado" && filter[val] !== undefined){
            dataReturn.estado = filter[val];
        } else if (val === "estadoUrgente" && filter[val] !== undefined){
            dataReturn.estadoUrgente = filter[val];
        } else if (val === "colores" && filter[val] !== undefined){
            if (filter[val].findIndex(x => x === MAP_PROPS_ANIMAL_CONFIG.color.default.label) < 0){
                dataReturn.color = filter[val].join(",");
            }
        } else if (val === "caracters" && filter[val] !== undefined){
            if (filter[val].findIndex(x => x === "TODOS") < 0){
                dataReturn.caracter = filter[val].join(",");
            }
        } else if (val === "chip" && filter[val] !== undefined){
            dataReturn.chip = filter[val];
        } else if (val === "vacuna" && filter[val] !== undefined){
            dataReturn.vacunas = filter[val];
        } else if (val === "ppp" && filter[val] !== undefined){
            dataReturn.ppp = filter[val];
        } else if (val === "ignoreList" && filter[val] !== undefined){
            dataReturn.ignoreList = filter[val];
        } else if (val === "id_protectora" && filter[val] !== undefined){
            dataReturn.id_protectora = filter[val];
        }
    });

    return dataReturn;
}

function parserBasicData(data) {
    let dataReturn = {};
    Object.keys(data).forEach((val) => {
        if (val === "especieSeleccionada" && data[val] !== undefined){
            if (data[val] !== MAP_PROPS_ANIMAL_CONFIG.especie.default.value){
                dataReturn.especie = data[val];
            }
        } else if (val === "sexoSeleccionado" && data[val] !== undefined){
            if (data[val] === MAP_PROPS_ANIMAL_CONFIG.sexo.macho.value || data[val] === MAP_PROPS_ANIMAL_CONFIG.sexo.hembra.value){
                dataReturn.sexo = data[val];
            }
        } else if (val === "tamaniosSeleccionados" && data[val] !== undefined && data[val].length > 0){
            dataReturn.tamano = data[val].join(",");
        } else if (val === "edadesSeleccionadas" && data[val] !== undefined && data[val].length > 0){
            dataReturn.edad = data[val].join(",");
        } else if (val === "razasSeleccionadas" && data[val] !== undefined && data[val].length > 0){
            if (data[val].findIndex(x => x === "TODAS") < 0){
                dataReturn.raza = data[val].join(",");
            }
        } else if (val === "razaSeleccionada" && data[val] !== undefined && data[val].length > 0){
            // if (data[val] !== "TODAS") {
            if (data[val] !== undefined){
                dataReturn.raza = data[val];
            }
        }
    });

    return dataReturn;
}

function parserAdvancedData(data) {
    let dataReturn = {};
    Object.keys(data).forEach((val) => {
        if (val === "estadoAnimalSeleccionado" && data[val] !== undefined){
            dataReturn.estado = data[val];
        } else if (val === "estadoUrgenteSeleccionado" && data[val] !== undefined){
            dataReturn.estadoUrgente = data[val];
        } else if (val === "coloresAnimalSeleccionados" && data[val] !== undefined){
            if (data[val].findIndex(x => x === "TODOS") < 0){
                dataReturn.color = data[val].join(",");
            }
        } else if (val === "caractersAnimalSeleccionados" && data[val] !== undefined){
            if (data[val].findIndex(x => x === "TODOS") < 0){
                dataReturn.caracter = data[val].join(",");
            }
        } else if (val === "chipSeleccionado" && data[val] !== undefined){
            dataReturn.chip = data[val];
        } else if (val === "vacunaSeleccionada" && data[val] !== undefined){
            dataReturn.vacunas = data[val];
        } else if (val === "pppSeleccionado" && data[val] !== undefined){
            dataReturn.ppp = data[val];
        }
    });

    return dataReturn;
}

// **************************FIN GETS ANIMALS*******************************

// =========================================================================
//                          CARTAS DETALLES ANIMAL
// =========================================================================

// -------------------------
// GENERAL
// -------------------------


export function resetInfoProtectoraDetail(animalControl) {
    //console.log("actionsAnimalList::resetInfoProtectoraDetail() -> animalControl = '" + animalControl + "'");
    return (dispatch, getState) => {
        if (animalControl === "animals"){
            dispatch({type: LOAD_PROTECTORA_DETAIL, payload: {infoProtectoraDetail: {}}});
        } else if (animalControl === "animalsProtectora"){
            dispatch({type: LOAD_PROTECTORA_DETAIL_PROTECTORA, payload: {infoProtectoraDetail: {}}});
        }
    }
}

export function resetAnimalsProtectora() {
    //console.log("actionsAnimalList::resetAnimalsProtectora()");
    return (dispatch, getState) => {
        dispatch({type: GET_ANIMALS_PROTECTORA, payload: {}});
    }
}


export function getProtectoraById(id, animalControl, tipo) {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: {
                tipo: tipo
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/protectora/" + id,
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);
                if (animalControl === "animals"){
                    dispatch({type: LOAD_PROTECTORA_DETAIL, payload: {infoProtectoraDetail: response}});
                } else if (animalControl === "animalsProtectora"){
                    dispatch({type: LOAD_PROTECTORA_DETAIL_PROTECTORA, payload: {infoProtectoraDetail: response}});
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}

export function getProtectoraByAnimalId(idAnimal, animalControl, tipo) {
    return (dispatch, getState) => {
        //console.log("actionsAnimalList::getProtectoraByAnimalId::()");
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: {
                tipo: tipo
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/animal/" + idAnimal + "/protectora",

        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);
                if (animalControl === "animals"){
                    dispatch({type: LOAD_PROTECTORA_DETAIL, payload: {infoProtectoraDetail: response}});
                } else if (animalControl === "animalsProtectora"){
                    dispatch({type: LOAD_PROTECTORA_DETAIL_PROTECTORA, payload: {infoProtectoraDetail: response}});
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}

export function loadInfoProtectoraDetailImagenYVideo(id, tipo) {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: {
                tipo: tipo
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/protectora/" + id,
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);
                dispatch({
                    type: LOAD_IMAGEN_VIDEO_PROTECTORA, payload: {
                        galeria_imagenes: response.galeria_imagenes,
                        galeria_videos: response.galeria_videos
                    }
                });
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}

export function changeElementsPerRow(elements_per_row, animalControl) {
    return (dispatch, getState) => {
        if (getState().animals.elementsPerRow !== elements_per_row){
            if (animalControl === "animals"){
                dispatch({type: CHANGE_ELEMENTS_PER_ROW, payload: {elementsPerRow: elements_per_row}});
            } else if (animalControl === "animalsProtectora"){
                dispatch({type: CHANGE_ELEMENTS_PER_ROW_PROTECTORA, payload: {elementsPerRow: elements_per_row}});
            }
        }
    }
}

export function imageLoaded(animalControl) {
    return (dispatch, getState) => {
        if (animalControl === "animals"){
            dispatch({type: IMAGE_LOADED, payload: {imagesLoaded: getState().animals.imagesLoaded + 1}});
            isReady(dispatch, getState().animals.imagesLoaded, getState().animals.imagesError, getState().animals.imagesOnPage, animalControl);
        } else if (animalControl === "animalsProtectora"){
            dispatch({
                type: IMAGE_LOADED_PROTECTORA,
                payload: {imagesLoaded: getState().animalsProtectora.imagesLoaded + 1}
            });
            isReady(dispatch, getState().animalsProtectora.imagesLoaded, getState().animalsProtectora.imagesError, getState().animalsProtectora.imagesOnPage, animalControl);
        }
    }
}

export function imageError(animalControl) {
    return (dispatch, getState) => {
        if (animalControl === "animals"){
            dispatch({type: IMAGE_ERROR, payload: {imagesError: getState().animals.imagesError + 1}});
            isReady(dispatch, getState().animals.imagesLoaded, getState().animals.imagesError, getState().animals.imagesOnPage, animalControl);
        } else if (animalControl === "animalsProtectora"){
            dispatch({
                type: IMAGE_ERROR_PROTECTORA,
                payload: {imagesError: getState().animalsProtectora.imagesError + 1}
            });
            isReady(dispatch, getState().animalsProtectora.imagesLoaded, getState().animalsProtectora.imagesError, getState().animalsProtectora.imagesOnPage, animalControl);
        }
    }
}

export function resetReady(animalControl) {
    return (dispatch, getState) => {
        if (animalControl === "animals"){
            dispatch({
                type: RESET_READY, payload: {
                    isReady: false,
                    imagesLoaded: 0,
                    imagesError: 0
                }
            });
        } else if (animalControl === "animalsProtectora"){
            dispatch({
                type: RESET_READY_PROTECTORA, payload: {
                    isReady: false,
                    imagesLoaded: 0,
                    imagesError: 0
                }
            });
        }
    }
}

function isReady(dispatch, loaded, error, total, animalControl) {
    if (loaded + error >= total){
        if (animalControl === "animals"){
            dispatch({type: CHANGE_IS_READY, payload: {isReady: true}});
        } else if (animalControl === "animalsProtectora"){
            dispatch({type: CHANGE_IS_READY_PROTECTORA, payload: {isReady: true}});
        }
    }
}

export function remove(infoAdminProtectora, animalId) {
    return (dispatch, getState) => {
        const datos_base64 = btoa(infoAdminProtectora.user + ":" + infoAdminProtectora.password);
        $.ajax({
            type: "DELETE",
            dataType: "json",
            contentType: false,
            processData: false,
            cache: false,
            crossDomain: true,
            beforeSend: function (req) {
                req.setRequestHeader("Authorization", "Basic " + datos_base64);
            },
            url: `/api/animal/${animalId}`,
        })
            .done(function (_response, _textStatus, _jqXHR) {
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
            })
            .fail(function (jqXHR, _textStatus, _errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: jqXHR.status}});
            });
    }
}

export function removing(isRemoving, animalControl) {
    return (dispatch, getState) => {
        if (animalControl === "animals"){
            dispatch({type: CHANGE_IS_REMOVING, payload: {isRemoving}});
        } else if (animalControl === "animalsProtectora"){
            dispatch({type: CHANGE_IS_REMOVING_PROTECTORA, payload: {isRemoving}});
        }
    }
}

export function modeEmail(key, animalControl) {
    //console.log("modeEmail::modeEmail()");
    return (dispatch, getState) => {
        if (animalControl === "animals"){
            dispatch({type: MODE_EMAIL, payload: {modeEmail: key}});
        } else if (animalControl === "animalsProtectora"){
            if (getState().animalDetailProtectora.modeEmail_2){
                dispatch({type: MODE_EMAIL_PROTECTORA_2, payload: {modeEmail_2: false}});
            }
            dispatch({type: MODE_EMAIL_PROTECTORA, payload: {modeEmail: key}});
        } else if (animalControl === "animalsProtectora2"){
            if (getState().animalDetailProtectora.modeEmail){
                dispatch({type: HIDE_ANIMAL_DETAIL_PROTECTORA, payload: {show: false, infoAnimalDetail: {}}});
                dispatch({type: MODE_EMAIL_PROTECTORA, payload: {modeEmail: false}});
            }
            dispatch({type: MODE_EMAIL_PROTECTORA_2, payload: {modeEmail_2: key}});
        }
    }
}

export function resetShowVideoProtectora() {
    return (dispatch, getState) => {
        dispatch({type: SHOW_IMAGEN_VIDEO_PROTECTORA, payload: {show: false}});
    }
}

export function showImagenVideoProtectora() {
    return (dispatch, getState) => {
        dispatch({
            type: SHOW_IMAGEN_VIDEO_PROTECTORA,
            payload: {show: !getState().animalDetailProtectoraImagenYVideo.show}
        });
    }
}


// **************************CARTAS DETALLES ANIMAL*******************************

const info_razas_cache = {}

export function getInfoRaza(especie, raza) {
    return (dispatch, getState) => {
        if (info_razas_cache[`${especie}_${raza}`]){
            dispatch({
                type: SAVE_INFO_RAZA, payload: info_razas_cache[`${especie}_${raza}`]
            });
        } else {

            $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                data: {},
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // Asincronía.
                async: false,
                // URL a la que se enviará la solicitud Ajax
                url: `/api/config/animalSpecies/${especie}/${raza}`,
            })
                .done(function (data, textStatus, jqXHR) {
                    info_razas_cache[`${especie}_${raza}`] = data
                    dispatch({
                        type: SAVE_INFO_RAZA, payload: data
                    });
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    let errorStr;
                    if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                        errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                    } else {
                        errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                    }

                    if (console && console.log){
                        console.log("La solicitud a fallado: " + errorStr);
                    }
                });
        }

    }
}

